import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";
import React from "react";

import { Icon } from "@/components/atoms/media/Icon";
import { IconEnum } from "@/enums";
import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./TopTip.module.css";

const ref = "top-tip";

interface TopTipProps extends Partial<CommonProps> {
  ariaLabel?: string;
  children?: React.ReactNode;
  distinct?: boolean;
  icon?: IconDefinition | IconEnum;
  text?: string;
  uniform?: boolean;
  noBorder?: boolean;
}

function useTopTip(props: TopTipProps) {
  const { ariaLabel, color, id = createId(ref), text, noBorder } = props;
  const className = clsx(
    styles[ref],
    color && styles[color],
    props.distinct && styles.distinct,
    props.uniform && styles.uniform,
    noBorder && styles.noBorder,
    props.className,
  );

  return {
    ariaLabel,
    children: props.children,
    className,
    icon: props.icon,
    id,
    text,
  };
}

function TopTip(props: TopTipProps) {
  const { ariaLabel, children, className, icon, id, text } = useTopTip(props);

  return (
    <aside className={className} id={id} aria-label={ariaLabel}>
      {icon && <Icon name={icon} />}
      {text && <span>{text}</span>}
      {children && <section>{children}</section>}
    </aside>
  );
}

export default TopTip;
export { TopTip, type TopTipProps };
